import EzController from 'controllers/ez-base-controller';
import Cookies from 'js-cookie';
import { triggerCustomEvent } from 'lib/helpers';
import events from 'lib/events';

export default class LocalePromptController extends EzController {
  connect() {
    const waitForGA = setInterval(() => {
      if (document.querySelector('[data-controller="google-analytics"][data-loaded=true]')) {
        triggerCustomEvent(events.locale_prompt.locale_prompt_connects, {
          currentLocale: this.element.dataset.localeCurrent,
          recommendedLocale: this.element.dataset.localeRecommended,
        });
        clearInterval(waitForGA);
      }
    }, 100);
    this.flagLoaded();
  }

  dismissPrompt() {
    triggerCustomEvent(events.locale_prompt.locale_prompt_dismissed, {
      currentLocale: this.element.dataset.localeCurrent,
      recommendedLocale: this.element.dataset.localeRecommended,
    });

    Cookies.set('locale_prompt_dismissed', true);
    this.element.remove();
  }

  acceptPrompt(event) {
    triggerCustomEvent(events.locale_prompt.locale_prompt_accepted, {
      currentLocale: this.element.dataset.localeCurrent,
      recommendedLocale: this.element.dataset.localeRecommended,
    });

    window.location = event.target.dataset.acceptedLocaleUrl;
  }

  sendLangSwitchEvent(event) {
    triggerCustomEvent(events.locale_prompt.switch_language, {
      currentLocale: this.element.dataset.localeCurrent,
      recommendedLocale: this.element.dataset.localeRecommended,
      toLang: event.target.dataset.locale,
    });
  }
}
